import { useEffect, useState } from "react"
import { useSocket } from "../contexts/socket"

export const usePricesSocket = () => {
    const socket = useSocket()
    const [pricesList, setPricesList] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (!socket) return

        const handlePrices = (data) => {
            setPricesList(data.map((item) => {
                item['changes.24h.changePresent'] = item?.changes?.['24h']?.changePresent || 0
                return item
            }))
            setLoading(false)
        }

        socket.on("prices", handlePrices)
        socket.emit("get.prices")

        return () => {
            socket.off("prices", handlePrices)
        }
    }, [socket])

    return { pricesList, loading }
}
